interface EmptyStateProps {
  title: string;
  body: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export function EmptyState({ title, body, action }: EmptyStateProps) {
  return (
    <div className="app-empty-state">
      <h3>{title}</h3>
      <p>{body}</p>
      {action && (
        <button
          onClick={action.onClick}
          className="app-primary-button"
        >
          {action.label}
        </button>
      )}
    </div>
  );
}
